import React from 'react';
import { FormQuestion } from '../types';

interface QuestionEditorProps {
  question: FormQuestion;
  index: number;
  onQuestionChange: (index: number, updatedQuestion: FormQuestion) => void;
  onDelete: (index: number) => void;
  onMove: (index: number, direction: 'up' | 'down') => void;
  isFirst: boolean;
  isLast: boolean;
}

const QUESTION_TYPES = [
  'text', 'long-text', 'number', 'rating', 
  'select', 'boolean-with-details', 'group', 'repeater'
];

const QuestionEditor: React.FC<QuestionEditorProps> = ({
  question,
  index,
  onQuestionChange,
  onDelete,
  onMove,
  isFirst,
  isLast,
}) => {
  
  const handleChange = (field: keyof FormQuestion, value: any) => {
    onQuestionChange(index, { ...question, [field]: value });
  };

  const handleOptionsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const options = e.target.value.split(',').map(opt => opt.trim()).filter(Boolean);
    handleChange('options', options);
  };

  return (
    <div className="question-editor-card">
      <div className="question-editor-header">
        <h4>Question #{index + 1}</h4>
        <div className="question-actions">
          <button onClick={() => onMove(index, 'up')} disabled={isFirst} className="move-btn">↑</button>
          <button onClick={() => onMove(index, 'down')} disabled={isLast} className="move-btn">↓</button>
          <button onClick={() => onDelete(index)} className="delete-question-btn">Delete</button>
        </div>
      </div>
      <div className="form-field">
        <label htmlFor={`q-label-${index}`}>Question Label</label>
        <input
          id={`q-label-${index}`}
          type="text"
          value={question.label}
          onChange={(e) => handleChange('label', e.target.value)}
        />
      </div>
      <div className="form-field">
        <label htmlFor={`q-type-${index}`}>Question Type</label>
        <select
          id={`q-type-${index}`}
          value={question.type}
          onChange={(e) => handleChange('type', e.target.value)}
        >
          {QUESTION_TYPES.map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>
      {question.type === 'select' && (
        <div className="form-field">
          <label htmlFor={`q-options-${index}`}>Options (comma-separated)</label>
          <textarea
            id={`q-options-${index}`}
            value={question.options?.join(', ') || ''}
            onChange={handleOptionsChange}
            placeholder="e.g., Option 1, Option 2, Option 3"
            rows={2}
          />
        </div>
      )}
    </div>
  );
};

export default QuestionEditor; 